import axios from 'axios';
import { apiBaseUrl, hubBaseUrl } from '@/utils/hub-url';

const authError = (error) => {
    console.log(error);
    if (error?.response?.status === 401 && error?.config.url !== '/login' && error.response.data.code !== 'demo-unavailable') {
        localStorage.removeItem('wp_token');
        localStorage.removeItem('api_token');
        localStorage.removeItem('selectedTeam');
        window.location.replace(`${window.location.protocol}//${window.location.host}/welcome`);
    }

    if (error?.response?.status === 403 && error.response.data.code === 'jwt_auth_invalid_token') {
        localStorage.removeItem('wp_token');
        localStorage.removeItem('api_token');
        localStorage.removeItem('selectedTeam');
        window.location.replace(`${window.location.protocol}//${window.location.host}/welcome`);
    }
    return Promise.reject(error);
};

const wpToken = localStorage.getItem('wp_token');
const wp = axios.create({
    baseURL: `${hubBaseUrl}/wp-json/worksends/v1/`,
    // baseURL: `${process.env.VUE_APP_WP_BASE_URL}/api/v1/`,
    headers: {
        Authorization: wpToken ? `Bearer ${wpToken}` : '',
    },
});
wp.interceptors.response.use((response) => response, authError);

const apiToken = localStorage.getItem('api_token');
const api = axios.create({
    baseURL: `${apiBaseUrl}/api/v1/`,
    headers: {
        Authorization: apiToken ? `Bearer ${apiToken}` : '',
    },
});
api.interceptors.response.use((response) => response, authError);

export { wp, api };
